import { IListItem } from '../../list-page/interfaces/interfaces';
import ProductPriceFormat from './product-price-format';
import ProductClock from '../product-clock/product-clock';
import { ProductDepartmentEnum } from '../enums/product-department-enum';

interface IProductPricesMerchProps {
    product: IListItem,
    isFirstMerchRowHidden?: boolean,
    isClockHidden?: boolean,
}

const ProductListPricesMerch = (props: IProductPricesMerchProps) => {

    const product = props.product;
    // const withCouponEnabled = product.couponCampaignID > 0;

    // handle subscription + product options (variants)
    let departmentID = Number(product.skuDepartmentID) || 0;

    if(departmentID === 0 && product.departmentID > 0){
        departmentID = product.departmentID;
    }

    // subscription + variants
    const isSubscriptionVariants = departmentID === ProductDepartmentEnum.Subscription ||
                                            departmentID === ProductDepartmentEnum.SampleMakerSubscriptions ||
                                            departmentID === ProductDepartmentEnum.VoiceRegenSubscriptions;
    const variantText = isSubscriptionVariants ? (product.optionName === 'Annual' ? '/year' : '/month') : '';


    return (
        <div className="flex flex-col">

            {/* prices row #1: if IsVariantsPriceSame = True, display Now */}
            {
                props.isFirstMerchRowHidden !== true &&
                <div className="flex items-center">
                    { product.isVariantsPriceSame ? <span>Now</span> : <span>From</span> }
                </div>
            }

            {/* prices row #2 */}
            <div className="flex items-center">

                {/* main price */}
                <span className="text-xl font-bold text-gray-700">
                    { product.isVariantsPriceSame && <ProductPriceFormat price={product.skuPrice} /> }
                    { !product.isVariantsPriceSame && <ProductPriceFormat price={product.variantsMinimalPrice} /> }

                    { variantText && <span>{ variantText }</span> }
                </span>

            </div>

            {
                props.isClockHidden !== true && product.saleEndDate &&
                <div className="mt-4">
                    <ProductClock saleEndDate={ new Date(product.saleEndDate) } />
                </div>
            }
        </div>
    )
};

export default ProductListPricesMerch;